import React, { useState } from 'react';
import { ImageIcon } from 'lucide-react';

const ColorCard = ({ item, onClick }) => {
  const [imgError, setImgError] = useState(false);
  const hasImage = !!item.image && !imgError;
  const hasSwatchColor = !!item.swatchColor;

  return (
    <button
      type="button"
      onClick={() => onClick(item)}
      className="group text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-[#6BA797] focus-visible:ring-offset-2 rounded-sm flex flex-col"
    >
      {/* Image area — fixed square so cards stay aligned regardless of title length */}
      <div
        className="relative w-full overflow-hidden bg-neutral-200 border border-neutral-200"
        style={{ aspectRatio: '1 / 1' }}
      >
        {hasImage ? (
          <img
            src={item.image}
            alt={item.name}
            loading="lazy"
            onError={() => setImgError(true)}
            className="absolute inset-0 w-full h-full object-cover"
          />
        ) : hasSwatchColor ? (
          <div
            className="absolute inset-0"
            style={{
              backgroundColor: item.swatchColor,
              border: item.swatchBorder ? `1px solid ${item.swatchBorder}` : undefined,
              boxSizing: 'border-box',
            }}
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-neutral-200 to-neutral-300">
            <ImageIcon
              className="w-10 h-10 text-neutral-400 group-hover:text-neutral-500 transition-colors"
              strokeWidth={1.25}
            />
          </div>
        )}

        {/* Hover overlay */}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300" />

        {/* Price badge */}
        <div className="absolute top-2 right-2 bg-white/90 backdrop-blur-sm text-neutral-800 text-[11px] font-semibold px-2 py-0.5 rounded">
          {item.price}
        </div>
      </div>

      {/* Title area — fixed min-height so wrapped titles don't push the image */}
      <div
        className="mt-3 flex flex-col justify-start"
        style={{ minHeight: '54px' }}
      >
        <h3
          className="text-[15px] font-semibold text-neutral-800 leading-snug group-hover:text-[#6BA797] transition-colors"
          style={{ fontFamily: "'Playfair Display', Georgia, serif", margin: 0 }}
        >
          {item.name}
        </h3>
        <p
          className="text-[12px] text-neutral-500 mt-0.5"
          style={{ fontFamily: "'Open Sans', sans-serif", margin: 0 }}
        >
          {item.manufacturer}
        </p>
      </div>
    </button>
  );
};

export default ColorCard;
